import React from 'react';
import { Label, Icon } from "semantic-ui-react";
import { isDownloadable } from "../utils/attachmentTypes";

const DownloadLabel = ({ document: { documentUrl, attachmentContentType } }) => (
    <a href={documentUrl} download>
      <Label
        basic
        size="mini"
        color={"blue"}
        style={{ cursor: 'pointer' }}>
        download
        {!isDownloadable(attachmentContentType) &&
          <Icon name='warning' color="red"/>}
      </Label>
  </a>
)

export default DownloadLabel;



// WEBPACK FOOTER //
// ./src/component/DownloadLabel.js